<template>
  <div
    class="App-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
    :class="{
      'is-disabled': disableState,
      'is-error': isError
    }"
  >
    <input
      class="App-textfield__input mdl-textfield__input"
      :class="{
        'is-error': isError,
        'is-cursive': isCursive,
        'is-proxy-holder': isProxyHolder
      }"
      :type="inputType"
      :maxlength="charLimit"
      :placeholder="placeholder"
      :disabled="disableState"
      @input="notify"
      :id="fieldId"
      :value="bvalue"
      @keyup.enter="enterPressed"
    />

    <label
      class="mdl-textfield__label perm-label"
      :class="{'is-error': isError}"
      for="textfield"
    >
      {{ label }}
    </label>
    <span v-if="showCharsLimit" class="char-limit-label">
      {{ bvalue.length }} / {{ charLimit }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    fieldId: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    },
    bvalue: {
      type: [String, Number]
    },
    type: {
      type: String
    },
    isDisabled: {
      type: Boolean
    },
    isError: {
      type: Boolean,
      default: false
    },
    showCharsLimit: {
      type: Boolean,
      default: false
    },
    charLimit: {
      type: String,
      default: '100'
    },
    isCursive: {
      type: Boolean,
      default: false
    },
    isProxyHolder: {
      type: Boolean,
      defualt: false
    }
  },
  computed: {
    // Default field type to text unless otherwise specified
    inputType() {
      return this.type ? this.type : 'text';
    },
    disableState() {
      return this.isDisabled;
    }
  },
  methods: {
    // Notify the parent on input
    notify(e) {
      this.$emit('inputting', e.target.value, this.fieldId);
    },
    enterPressed() {
      this.$emit('enter-pressed', this.fieldId);
    }
  },
  created() {
    // Listen for the call to determine if this input should be focused
    this.$events.$on('go-input', input => {
      if (input === this.fieldId) {
        this.$el.children[0].focus();
      }
    });
  },
  beforeDestroy() {
    this.$events.$off('go-input', input => {
      if (input === this.fieldId) {
        this.$el.children[0].focus();
      }
    });
  },
  mounted() {
    this.$nextTick(() => {
      componentHandler.upgradeAllRegistered();
    });
  }
};
</script>

<style scoped>
.App-textfield {
  display: block;
  padding-right: 20px;
}
.App-textfield__input {
  background-color: #ffffff;
  padding: 10px;
  margin-top: 10px;
  border-radius: 4px;
}
.mdl-textfield .mdl-textfield__input,
.mdl-textfield.is-disabled .mdl-textfield__input {
  transition-duration: 0.2s;
}

.mdl-textfield__label {
  overflow: visible;
}

.perm-label {
  color: rgb(63, 81, 181);
  font-size: 12px;
  top: 4px;
  visibility: visible;
}
.char-limit-label {
  font-size: 12px;
  position: absolute;
  width: 100%;
  text-align: right;
}
.is-error > input.is-error,
.is-error > label.is-error {
  color: red;
}
.is-cursive {
  font-size: 25px;
  font-family: 'Brush Script MT', cursive;
}

.is-proxy-holder {
  padding-left: 35px;
  font-size: 14px;
  width: 340px;
}
</style>
